import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 429,
  name: 'Too Many Requests',
  description:
    'The client has sent too many requests in a given time window. The server is rate limiting to protect itself from being overwhelmed. The Retry-After header usually indicates when to try again.',
  causes: [
    'Your application is making API calls faster than the rate limit allows — e.g., more than 100 requests per minute.',
    'Multiple clients share the same API key or IP address, and their combined traffic exceeds the limit.',
    'A bug causes a retry loop or rapid polling, sending requests much faster than intended.',
  ],
  fixes: [
    'Check the Retry-After header in the response. Wait that many seconds before retrying. Implement exponential backoff in your retry logic.',
    'Reduce request frequency. Cache responses, batch operations, or use webhooks instead of polling.',
    'If you need a higher rate limit, check if the API offers a higher tier. Distribute requests across multiple API keys or IP addresses if allowed.',
  ],
  monitoringTip:
    'Uptrack uses reasonable check intervals (30s minimum) that stay well within rate limits of virtually all services. If your own API starts returning 429 to legitimate traffic, Uptrack alerts you to the rate limiting issue.',
}

export const Route = createFileRoute('/_site/http/429')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
